<div
  fxLayout="column"
  fxLayoutAlign="space-between center"
  fxFill
  class="container-padding"
>
  <div fxFlex="initial">
    <h1 mat-dialog-title>Configuração Global</h1>
  </div>

  <div fxFlex fxLayout="column" fxFill fxLayoutGap="8">
    <div fxFlex fxLayout="row" fxLayoutGap="8">
      <mat-card fxFlex fxLayout="row" fxLayoutGap="8" fxLayoutAlign="center">
        <div fxFlex="500px" fxLayout="column" fxLayoutGap="16">
          <!-- Grupo de Juros - estilo inline direto -->
          <div style="display: flex; flex-direction: row; margin-bottom: 16px;">
            <div style="width: 30%; padding-right: 16px;">
              <app-input
                [config]="getFieldConfig('interest')"
                [typeCes]="typeCes"
                [group]="form"
              ></app-input>
            </div>
            <div style="width: 70%;">
              <app-input
                [config]="getFieldConfig('interestDescription')"
                [typeCes]="typeCes"
                [group]="form"
              ></app-input>
            </div>
          </div>

          <!-- Grupo de Multa - estilo inline direto -->
          <div style="display: flex; flex-direction: row;">
            <div style="width: 30%; padding-right: 16px;">
              <app-input
                [config]="getFieldConfig('fine')"
                [typeCes]="typeCes"
                [group]="form"
              ></app-input>
            </div>
            <div style="width: 70%;">
              <app-input
                [config]="getFieldConfig('fineDescription')"
                [typeCes]="typeCes"
                [group]="form"
              ></app-input>
            </div>
          </div>
        </div>
      </mat-card>
    </div>

    <!-- Botões no final -->
    <div style="width: 100%; display: flex; justify-content: flex-end; margin-top: 16px;">
      <!-- <button
        class="custom-button"
        type="button"
        (click)="back()"
        mat-raised-button
        style="margin-right: 8px;"
      >
        VOLTAR
      </button> -->
      <button
        *ngIf="typeCes !== typeCesEnum.SHOW"
        class="custom-button btn-save"
        type="submit"
        variant="contained"
        mat-raised-button
        [disabled]="form.invalid"
        (click)="save()"
      >
        SALVAR
      </button>
    </div>
  </div>
</div>
